import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Website/Home"; // Adjust the path if necessary
import Course from "./Website/Course"; // Create Service Component
import About from "./Website/About"; // Create About Component
import Contact from "./Website/Contact"; // Create Contact Component

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/course" element={<Course />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
